<ng-container *transloco="let t">
  @if (
    {
      activeLang: activeLang$ | async,
      readOnly: readOnly$ | async,
      errorMessage: errorMessage$ | async,
    };
    as data
  ) {
    <lib-input-container
      [label]="t('oreg_account_payout_account')"
      [labelHeader]="true"
      [required]="true"
      [requiredTextEnd]="false"
      [labelPrefix]="questionNumber$ | async"
      [errorText]="data.errorMessage"
      [headLine]="
        question.translations?.list['headLine']
          | translate: data.activeLang : question.structure.headLine
      "
      [description]="
        question.translations?.list['description']
          | translate: data.activeLang : question.structure.description
      "
      [questionMarkText]="
        question.translations?.list['questionMarkText']
          | translate: data.activeLang : question.structure.questionMarkText
      "
    >
      @if (!accountAnswer()) {
        <button
          vinnova-button-primary
          type="button"
          (click)="onOpenOrEditAccountModal()"
          [disabled]="data.readOnly"
          [attr.aria-label]="t('oreg_account_add_account')"
        >
          {{ t('oreg_account_add_account') }}
        </button>
      }
      @if (accountAnswer()) {
        <lib-list-item
          [removeVisible]="!data.readOnly"
          [editVisible]="
            !data.readOnly && accountAnswer().vinnovaStatus === 'New'
          "
          [readOnlyState]="data.readOnly"
          [editMode]="false"
          (edit)="onOpenOrEditAccountModal()"
          (remove)="removeAccount()"
        >
          <div view-title class="account-answer">
            @if (accountAnswer().countryName) {
              <p class="country">
                {{ accountAnswer().countryName }}
              </p>
            }
            @if (accountAnswer().number) {
              <p>
                <span>{{
                  accountAnswer().type === 'PlusGiro'
                    ? t('oreg_account_PlusGiro_number') + ':'
                    : accountAnswer().type === 'BankGiro'
                      ? t('oreg_account_bank_transfer_number') + ':'
                      : ''
                }}</span>
                {{ accountAnswer().number }}
              </p>
            }
            @if (accountAnswer().swift) {
              <p>
                <span>{{ t('oreg_account_swift') + ':' }}</span
                >{{ accountAnswer().swift }}
              </p>
            }
            @if (accountAnswer().iban) {
              <p>
                <span>{{ t('oreg_account_iban') + ':' }}</span
                >{{ accountAnswer().iban }}
              </p>
            }
            @if (accountAnswer().bsbCode) {
              <p>
                <span>{{ t('oreg_account_bsb_code') + ':' }}</span
                >{{ accountAnswer().bsbCode }}
              </p>
            }
            @if (accountAnswer().routingNumber) {
              <p>
                <span>{{ t('oreg_account_routing_number') + ':' }}</span
                >{{ accountAnswer().routingNumber }}
              </p>
            }
            @if (accountAnswer().fw) {
              <p>
                <span>{{ t('oreg_account_fw') + ':' }}</span
                >{{ accountAnswer().fw }}
              </p>
            }
          </div>
        </lib-list-item>
      }
    </lib-input-container>
  }
</ng-container>

<ng-template #accountModal>
  <lib-modal>
    <lib-account-layout
      (cancel)="onCloseAccountModal()"
      (accountSubmitted)="onAccountSubmitted($event)"
      [accountId]="accountAnswer()?.id"
      [worksiteId]="worksiteId"
      [isModal]="true"
    ></lib-account-layout>
  </lib-modal>
</ng-template>
